import React, { Component } from "react";
import { PropTypes } from "prop-types";
import cx from "classnames";
import { Grid } from "semantic-ui-react";
import Only from "react-only-when";
import { Amenities } from "../common";
import styles from "./styles.less";
import PriceDisplay from "../../containers/PriceDisplay";

class RoomboxDetailsHeader extends Component {
  renderPrice = room => {
    return (
      <div className={styles.priceTitle}>
        <PriceDisplay
          price={room.lowestPrice}
          currentCurrencyCode={room.currencyCode}
          fallBackCurrencySymbol={room.currency}
        >
          {convertedPrice => `${convertedPrice}`}
        </PriceDisplay>
      </div>
    );
  };

  onRoomDetailsClick = () => {
    const { room, onRoomDetailsClick } = this.props;
    onRoomDetailsClick(room.id);
  };

  renderHeaderShowContactUsBtn = () => {
    const { titles, onShowContactUsForm } = this.props;
    return (
      <button className={styles.scrollToRatesBtn} onClick={onShowContactUsForm}>
        {titles.ContactUs}
      </button>
    );
  };

  renderAmenities = () => {
    const { amenities, isRtl, isMobileView } = this.props;
    return (
      <Grid.Column
        textAlign={isRtl ? "left" : "right"}
        verticalAlign="middle"
        width={6}
        className={styles.amenities}
      >
        <Amenities
          isRtl={isRtl}
          amenities={amenities}
          isMobileView={isMobileView}
          includeName={true}
        />
      </Grid.Column>
    );
  };

  mobileHeader = () => {
    const { titles, room } = this.props;
    return (
      <Grid.Column
        tablet={16}
        computer={16}
        className={styles.headerMainContent}
      >
        <div className={styles.roomNameHeader}>{room.name}</div>
        <div
          className={styles.infoBtn}
          onClick={this.onRoomDetailsClick}
          onKeyDown={this.onRoomDetailsClick}
          role="button"
          tabIndex="0"
        >
          {titles.MoreDetails}
        </div>
      </Grid.Column>
    );
  };

  desktopHeader = () => {
    const { titles, room, onShowRatesClick, ratesGroupVisible } = this.props;
    return (
      <Grid.Column tablet={16} computer={16}>
        <div className={styles.headerMainContent}>
          <div className={styles.headerMainDesktopContent}>
            <div className={styles.titleRowWrapper}>
              <div className={styles.roomNameHeader}>{room.name}</div>
              <div
                className={styles.infoBtn}
                onClick={this.onRoomDetailsClick}
                onKeyDown={this.onRoomDetailsClick}
                role="button"
                tabIndex="0"
              >
                {titles.MoreDetails}
              </div>
            </div>
            <div className={styles.sideHeader}>
              <div className={styles.priceWrapper}>
                {titles.StartingFrom}
                <span className={styles.priceTitle}>
                  {this.renderPrice(room)}
                </span>
              </div>
            </div>
          </div>
          {!ratesGroupVisible && (
            <div className={cx(styles.buttonWrapper, styles.sideHeader)}>
              <button
                className={styles.scrollToRatesBtn}
                onClick={onShowRatesClick}
              >
                {titles.SelectRateBtn}
              </button>
              <div className={styles.buttonArrow} />
            </div>
          )}
        </div>
      </Grid.Column>
    );
  };

  render() {
    const { room, className, showFullHeaderDetails, isMobileView } = this.props;
    const isRequestedRoom = room.requestedRoom;
    return (
      <Grid className={cx(styles.roomboxDetailsHeader, className)}>
        <Grid.Row>
          {isMobileView ? this.mobileHeader() : this.desktopHeader()}
          <Only when={!isMobileView}>
            <Grid.Column computer={6} tablet={16} className={styles.sideHeader}>
              <Only when={showFullHeaderDetails}>
                <React.Fragment>
                  <Only when={isRequestedRoom}>
                    {this.renderHeaderShowContactUsBtn()}
                  </Only>
                </React.Fragment>
              </Only>
            </Grid.Column>
          </Only>
        </Grid.Row>
      </Grid>
    );
  }
}

RoomboxDetailsHeader.propTypes = {
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  titles: PropTypes.object,
  room: PropTypes.object,
  amenities: PropTypes.array,
  className: PropTypes.string,
  showFullHeaderDetails: PropTypes.bool,
  onRoomDetailsClick: PropTypes.func,
  onShowRatesClick: PropTypes.func,
  onShowContactUsForm: PropTypes.func,
  ratesGroupVisible: PropTypes.bool
};

export default RoomboxDetailsHeader;



// WEBPACK FOOTER //
// ./src/components/RoomboxDetailsHeader/RoomboxDetailsHeader.js